import { useCallback, useEffect, useState } from 'react';
import { fetchEntryLevelPrice, getCustomerById } from '../services/api';

const priceCache = new Map();

/**
 * Hook che aggiorna `entryLevelPrice` in allProducts
 * quando cambia la quantità di un prodotto.
 *
 * @param {Function} setProducts setter di allProducts
 * @returns {(product:Object, quantity:number) => void}
 */
export const useEntryLevelPrice = (setProducts) => {
  const [customerRoleId, setCustomerRoleId] = useState(null);

  // Recupero customer_id dallo user salvato in localStorage
  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem('user'));
    const customerId = stored?.customerId ?? stored?.customer_id;

    if (!customerId) return;

    (async () => {
      try {
        const { data: customer } = await getCustomerById(customerId);
        const roleId = customer.customer_role_id ?? customer.role_id;
        if (roleId) setCustomerRoleId(roleId);
        else console.warn('❗ customer_role_id non trovato');
      } catch (err) {
        console.error('Errore recupero customer:', err);
      }
    })();
  }, []);

  const updateEntryLevelPrice = useCallback(
    async (product, quantity) => {
      if (!product || !customerRoleId) return;

      const categoryId = product.category?.id;
      const listPrice = parseFloat(product.valore_di_mercato);
      const key = `${categoryId}|${listPrice}|${quantity}|${customerRoleId}`;

      console.log(`🔄 useEntryLevelPrice per prodotto ${product.product_code}`);
      console.log('➡️ category:', categoryId, 'listPrice:', listPrice, 'roleId:', customerRoleId);

      if (!priceCache.has(key)) {
        if (!categoryId || isNaN(listPrice)) return;

        try {
          const price = await fetchEntryLevelPrice({
            category_id: categoryId,
            price_range: listPrice,
            quantita: quantity,
            customer_role_id: customerRoleId,
          });
          priceCache.set(key, price);
        } catch (err) {
          console.error('Errore fetchEntryLevelPrice:', err);
          return;
        }
      }

      const fixed = priceCache.get(key);

      if (fixed == null || fixed === product.entryLevelPrice) return;

      console.log('✅ Aggiorno entryLevelPrice per', product.product_code, '->', fixed);

      setProducts(prev =>
        prev.map(p =>
          p.id === product.id ? { ...p, entryLevelPrice: fixed } : p
        )
      );
    },
    [setProducts, customerRoleId]
  );

  return updateEntryLevelPrice;
};

export default useEntryLevelPrice;
